import Backbone from 'backbone'
import template from './chart-designer-panel.hbs'
import $ from 'jquery'
import _ from 'lodash'
import constants from 'scoreboard/components/constants'

const ChartDesignerPanel = Backbone.View.extend({
	className: 'chart-designer-panel panel',

	/**
	 * @abstract
	 * @type String
	 */
	title: null,

	/** @type ChartDesigner */
	model: null,

	transitioning: false,

	initialize: function (options = {}) {
		this.active = false
		_.bindAll(this, 'setMaxHeight')
	},

	render: function() {
		if (this.$el.children().length === 0) {
			this.$el
				.append(template({
					title: this._getTitle()
				}))
				.data('cid', this.cid)
		}

		// Render hidden content on render so transitions work
		this.renderActiveContent(this.activeContent())
		this.body = $('body')
		this.panelContent = this.$('.chart-designer-panel-content')
		process.nextTick(() => this.prepareForTransitions())

		if (!this.attachedListeners) {
			this.attachListeners()
			this.attachedListeners = true
		}
		return this
	},

	attachListeners: function() {
		this.on('resize', () => this.prepareForTransitions())

		// #44190 flag that we are transitioning
		const panel = this.$el
		panel.on('transitionstart', e => {
			if (e.originalEvent.propertyName === 'height') {
				this.transitioning = true
			}
		})
		panel.on('transitionend', e => {
			if (e.originalEvent.propertyName === 'height') {
				this.transitioning = false
			}
		})

		// If user scrolls down and hovers over the panel, the panel's max-height
		// should be relative to the scroll position.
		this.scrollContainer = $('.scroll-container')
		this.scrollContainer.on('scroll', this.setMaxHeight)
	},

	// Sets the max-height of the panel to be 20px from the bottom of the
	// viewable area.
	setMaxHeight: function() {
		let topPosition = this.panelContent[0].getBoundingClientRect().top
		let maxHeight = this.body.height() - topPosition - constants.STANDARD_MARGIN
		this.panelContent.css('max-height', maxHeight)
	},

	prepareForTransitions: function() {
		this.setMaxHeight()
		let width = this.$el.width()
		let willExpand = width < 280
		this.$('.transition-container')
			.toggleClass('will-expand', willExpand)
			.css('width', width)

		// If we are using stacked panels for smaller display panes, we need to
		// change the alignment so we don't show both the active and inactive
		// displays at the same time.
		let isDialogPanel = this.$el.hasClass('dialog-panel')
		let isNarrowDisplay =
		this.body.hasClass('display-small') ||
		this.body.hasClass('display-medium')
		let stackedPanel =
			(isNarrowDisplay && !isDialogPanel) ||
			this.body.width() <= constants.MOBILE_WIDTH_BREAKPOINT &&
			isDialogPanel
		this.$el.toggleClass('is-stacked', stackedPanel)
		this.$el.closest('.chart-designer-editor')
			.toggleClass('has-stacked-panels', stackedPanel)
	},

	_getTitle: function() {
		return this.title
	},

	/**
	 * @abstract
	 */
	renderActiveContent: function (container) {},

	toggleActive: function (active) {
		if (this.active === active) {
			this.$el.toggleClass('is-selected', this.active)
			return
		}

		this.active = active

		this.$el.toggleClass('is-selected', this.active)

		this.renderActiveContent(this.activeContent())
	},

	activeContent: function (descendantSelector = '') {
		return this.$(`.chart-designer-panel-content ${descendantSelector}`)
	},

	refresh: function () {
		this.renderActiveContent(this.activeContent())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.scrollContainer.off('scroll', this.setMaxHeight)
	}
})

export default ChartDesignerPanel

ChartDesignerPanel.__filename__ = 'charts/edit/chart-designer-panel.js'
